export const HEADER_NAME_AREA = 'headerNameArea';
export const ITEM_NAME_AREA = 'itemNameArea';
export const DATE_SOON_AREA = 'dateSoonArea';
export const DATE_RANGE_AREA = 'dateRangeArea';
export const PAYER_AREA = 'payerArea';
export const REFERRAL_AREA = 'referralArea';
export const ORDER_REFERRAL_AREA = 'orderReferralArea';
